define('viewModels/dashboards/Dashboard',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'viewModels/SwitchedView',
    'services/agentDashboardAuth',
    'services/authService',
    'services/featureToggleService',
    'services/navHelper',
    'services/qm/qualityAuth',

    'viewModels/dashboards/EvaluatorDashboard',
    'viewModels/dashboards/QualityAdminDashboard'
], function (
    ko,
    _,
    ViewModel,
    SwitchedView,
    agentDashboardAuth,
    authService,
    featureToggleService, 
    navHelper,
    qualityAuthorization,
    EvaluatorDashboard,
    QualityAdminDashboard
) {
    'use strict';

    function getDashboardConfig() {
        var dashboards = [];
        //TODO: this dashboard should actually be more generic than just the 'supervisor' role, but there's no good way to do that now.
        if (qualityAuthorization.canViewCalibration() || qualityAuthorization.canAddEvaluation()) {
            dashboards.push({
                type: 'qualityAdmin',
                viewModel: QualityAdminDashboard
            });
        }
        if (qualityAuthorization.canEditScore() || qualityAuthorization.canEditEvaluation()) {
            dashboards.push({
                type: 'qualityEvaluator',
                viewModel: EvaluatorDashboard
            });
        }

        return dashboards;
    }

    var Dashboard = ViewModel.extend(function () {
        var self = this;
        self.dashboards = getDashboardConfig();
        self.showTabs = (self.dashboards.length > 1);

        self.setActiveDashboardTab = function (tab) {
            self.dashboardViews.setActiveView(tab);
        };

        self.showDefaultDashboard = function () {
            if (self.dashboards.length < 1) {
                if(agentDashboardAuth.canViewWfmSchedule() && !agentDashboardAuth.canViewAgentData()) {
                    navHelper.navigateTo('#/analytics/agents/schedule/me');
                } else if (agentDashboardAuth.canViewAgentData()) {
                    navHelper.navigateTo('#/analytics/agents/performance/me');
                } else {
                    navHelper.navigateTo('#interactions');
                }
            } else {
                self.dashboardViews.setActiveView(self.dashboards[0].type);
                if (self.dashboards[0].type === 'agent' && window.location.hash.indexOf('dashboard/agent') < 0) {
                    if(agentDashboardAuth.canViewWfmSchedule() && !agentDashboardAuth.canViewAgentData()) {
                        navHelper.navigateTo('#/analytics/agents/schedule/me');
                    } else {
                        navHelper.navigateTo('#/analytics/agents/performance/me');
                    }
                }
            }
        };

        var dashboardViewOptions = _.reduce(self.dashboards, function (options, dashboard) {
            options[dashboard.type] = dashboard.viewModel;
            return options;
        }, {});
        self.dashboardViews = self.subView(SwitchedView, dashboardViewOptions);
        self.showDefaultDashboard();
    });

    return Dashboard;
});

